import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom'

import Home from './Home.js';
import About from './About.js';
import Partner from './Partner.js';
import Customer from './Customer.js';
import Pricing from './Pricing.js';
import Contact from './Contact.js';
import Signup from './Signup.js';

import Error from './Error.js';

export class Main extends Component {

	render = () => {
		return (
			<Switch>
				<Route exact path="/" component={Home} />
				<Route path="/about.html" component={About} />
				<Route path="/partner.html" component={Partner} />
				<Route path="/customer.html" component={Customer} />
				<Route path="/pricing.html" component={Pricing} />
				<Route path="/contact.html" component={Contact} />
				<Route path="/signup/*" component={Signup} />
				<Route path="*" component={Error} />
			</Switch>
		);
	}
}




// WEBPACK FOOTER //
// ./src/page/Main.js